import ordersService from './ordersService'

export default ordersService



// WEBPACK FOOTER //
// ../src/services/ordersService/index.js